import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { GenericResponse } from "admin/appModel/Generic";
import { LoginResponse } from "admin/baseLogin/LoginResponse";
import { ContactUsResponse } from "admin/utile/contactUs/contactUsForm/contact-us-form.component";
import { from, Observable, of, throwError } from "rxjs";
import { catchError, concatMap, mapTo, retryWhen, switchMap, take } from "rxjs/operators";

export abstract class BaseAccountService
{
    constructor(
        protected http: HttpClient) {

    }

    forgotPasswordRequest(email: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>("/AccountCalls/ForgotPasswordRequest", { Email: email });
    }

    forgotPassword(email: string, pass: string, token: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>("/AccountCalls/ForgotPassword", { Email: email, Password: pass, PasswordResetToken: token });
    }

    logout(): Observable<LoginResponse> {
        return this.http.post<LoginResponse>("/AccountCalls/LogOff", {})
            .pipe(
                catchError(error => {
                    if (error.status === 401) {
                        const response = new LoginResponse();
                        response.Success = true;

                        return of(response);
                    }

                    return throwError(error);
                }),
                retryWhen(errors =>
                    errors.pipe(
                        switchMap((error, count) => {
                            console.error("Cannot logoff user in, retry: " + count);

                            return of(error);
                        }),
                        take(3)
                    )
                )
            );
    }

    async refreshToken(): Promise<GenericResponse> {
        let response: GenericResponse;

        try {
            response = await this.http.post<GenericResponse>("/AccountCalls/RefreshToken", {}).toPromise();
        }
        catch (err) {
            console.error(err);

            response = new GenericResponse();
            response.success = false;
        }

        return response;
	}

	abstract sendMessage(message: string): Observable<ContactUsResponse>;
    abstract joinCompany(code: string): Observable<LoginResponse>;
    abstract createCompany(name: string, code: string): Observable<LoginResponse>;
    abstract isAuthenticated(): Observable<LoginResponse>;
    abstract hasCompanySet(): Observable<LoginResponse>;
    abstract register(email: string, password: string): Observable<LoginResponse>;
    abstract login(email: string, password: string): Observable<LoginResponse>;
}